import { QueryKeys } from '../../../enums/queryKeys'
import { InvoiceDocumentType } from '../enums/invoiceDocumentType'

export const getInvoiceQueryKey = (invoiceId?: string, documentType?: InvoiceDocumentType) => [
  QueryKeys.InvoiceZervant,
  invoiceId,
  documentType,
]
